// Mirrors Finkit.Permissions.User.FinkitUserPagesPermissions.RiskMonitoing.
export const RiskDashboardPermissions = {
  default: 'User.RiskMonitoring.RiskDashboard',
  byCcy: 'User.RiskMonitoring.ConsolidatedExposure.ByCcy',
  byUniqueId: 'User.RiskMonitoring.ConsolidatedExposure.ByUniqueId',
  autoMap: 'User.RiskMonitoring.AutoMap',
} as const;
